export default __webpack_public_path__ + "static/media/ReducingHeartRate_main.d3a1f2f7.png";